import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { DictionaryRequest } from '../../models/dictionary-request.model';

@Injectable()
export class DictionaryStoreService {
  constructor(private bafAgent: BafAgentService) {}

  getDictionary(
    attributeId: string,
    value: string,
    elementId: string,
    elementViewId: string
  ): Observable<any> {
    const request: DictionaryRequest = {
      attributeId: attributeId,
      elementId: elementId,
      elementViewId: elementViewId,
      query: '',
      page: 1,
      start: 0,
      limit: 99999
    };

    return this.bafAgent.getDictionary(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dictionary-store/dictionary-store.service.ts